import { computed, ref, watch } from 'vue';
import PostSaleManagementAPI from 'dashboard/api/postSaleManagement';

const currentPeriod = () => {
  const today = new Date();
  return { month: today.getMonth() + 1, year: today.getFullYear() };
};

const messageFrom = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.error || fallback;

export function usePostSaleManagement({ activeTab, dashboard, t, notify }) {
  const period = ref(currentPeriod());
  const deeds = ref({ grafico_linhas: [], linha_tempo_status: [] });
  const loadingDashboard = ref(false);
  const loadingDeeds = ref(false);
  const savingQueueUserId = ref(null);
  const queueUpdatedAt = ref(null);

  const queue = computed(() => dashboard.value.responsible_queue || []);

  const loadDashboard = async () => {
    loadingDashboard.value = true;
    try {
      const { data } = await PostSaleManagementAPI.dashboard();
      dashboard.value = { ...dashboard.value, ...(data || {}) };
      queueUpdatedAt.value = new Date();
    } catch (error) {
      notify(messageFrom(error, t('POST_SALE.MANAGEMENT.ALERTS.LOAD_ERROR')));
    } finally {
      loadingDashboard.value = false;
    }
  };

  const loadDeeds = async () => {
    loadingDeeds.value = true;
    try {
      const { data } = await PostSaleManagementAPI.deeds(period.value);
      deeds.value = data || { grafico_linhas: [], linha_tempo_status: [] };
    } catch (error) {
      notify(
        messageFrom(error, t('POST_SALE.MANAGEMENT.ALERTS.DEEDS_LOAD_ERROR'))
      );
    } finally {
      loadingDeeds.value = false;
    }
  };

  const updateQueue = async ({ userId, type, value }) => {
    savingQueueUserId.value = userId;
    try {
      await PostSaleManagementAPI.updateQueue(userId, {
        tipo: type,
        valor_checked: value,
      });
      await loadDashboard();
    } catch (error) {
      notify(messageFrom(error, t('POST_SALE.MANAGEMENT.ALERTS.QUEUE_ERROR')));
    } finally {
      savingQueueUserId.value = null;
    }
  };

  const setPeriod = value => {
    period.value = { ...period.value, ...value };
    return loadDeeds();
  };

  const refresh = () =>
    activeTab.value === 'escrituras' ? loadDeeds() : Promise.resolve();

  watch(
    activeTab,
    tab => {
      if (tab === 'fila') loadDashboard();
      if (tab === 'escrituras') loadDeeds();
    },
    { immediate: true }
  );

  return {
    deeds,
    loadDashboard,
    loadDeeds,
    loadingDashboard,
    loadingDeeds,
    period,
    queue,
    queueUpdatedAt,
    refresh,
    savingQueueUserId,
    setPeriod,
    updateQueue,
  };
}
